import React, { useState, useContext, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { ObjModal } from '../../../../contexts';


const MultiSelect = ( { label, db, value, options, bucket, formId = 'gen' } ) => {
    const { setDraftValues } = useContext( ObjModal );
    const [ v, setV ] = useState( '' );
    const [ plist, setPicklist ] = useState( [] );

    const handleDraft = ( e ) => {
        const selectedItems = Array.from( e, ( option ) => option.value );
        selectedItems.sort();
        setV( e );
        setDraftValues( prevState => (
            {
                ...prevState,
                [db]: selectedItems.join( ', ' )
            }
        ) );
    }

    useEffect( () => {
        if ( options && options[db] ) {
            setPicklist( options[db] );
        }
    }, [ options, db, bucket ] );

    useEffect( () => {
        if ( value && plist ) {
            let list = [];
            const vals = value.split( ', ' );
            vals.forEach( v => {
                const match = plist.find( f => f.value === v );
                if ( match ) {
                    list.push( match );
                }
            } );
            setV( list );
        }
    }, [ value, plist ] );

    return (
        <Col className='tf-obj-data-element'>
            <Form.Group as={Row} className='tf-form-group align-items-center' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                <Col xs='auto' className='tf-form-select-field me-1'>
                    <Select id={`${formId}-${db}`} isMulti={true} closeMenuOnSelect={false} isClearable={false} isSearchable={true} classNamePrefix='tf-multiselect' options={plist} value={v} onChange={handleDraft} />
                </Col>
            </Form.Group>
        </Col>
    )
}

export default MultiSelect;